import { Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-aboutus-contributors',
    templateUrl: './aboutus-contributors.component.html',
    styleUrls: ['./aboutus-contributors.component.scss'],
    standalone: false
})
export class AboutusContributorsComponent implements OnInit {

  contributorSections: any[];

  constructor(
    private dialogService: DialogService,
    private httpClient: HttpClient,
    private translate:TranslateService
    ){
    }

  async ngOnInit(){
      let lang = this.translate.currentLang;
      this.translate.setTranslation(lang,await import('../../../../assets/i18n/about-us/'+lang+'.json'),true);
    this.getContributors();
  }

  getContributors(){
    this.httpClient.get("/assets/about-us/json/Contributors.json").subscribe((data:any) =>{
      this.contributorSections = data.contributorSections;
    });
  }

  ok() {
    this.dialogService.complete({ data: null });
  }
}
